export const contactImage = require("../assets/group_.png");
export const plusIcon=require('../assets/plusImage.png');
export const supportImage=require('../assets/supportImage.png');
export const fileUploadIcon=require('../assets/fileUpload.png');
export const PdfIcon=require('../assets/pdfIcon.png');
export const DocIcon=require('../assets/DocIcon.png');
export const DocxIcon=require('../assets/DocxIcon.png');